import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import { PageContextProvider } from "utils/PageContext";
import { UserContextProvider } from "utils/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PageContextProvider>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </PageContextProvider>
);
